export default "__VITE_ASSET__C1ih1Vte__"